import { useEffect, useState } from 'react';
import MultiSelect from '@/components/ui/MultiSelect';

interface DealTypeMultiFilterProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: string[];
}

export default function DealTypeMultiFilter({ value, onChange, options }: DealTypeMultiFilterProps) {
  // Convert comma-separated string to array for multi-select
  const selectedArray = value ? value.split(',').filter(v => v.trim()) : [];
  
  // Initialize with all options selected by default when no value is set
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!isInitialized && options.length > 0) {
      // Set all options as selected by default when no value is provided
      if (!value || value.trim() === '') {
        const allOptionsString = options.join(',');
        const fakeEvent = {
          target: {
            name: 'deal_type',
            value: allOptionsString
          }
        } as React.ChangeEvent<HTMLSelectElement>;
        onChange(fakeEvent);
      }
      setIsInitialized(true);
    }
  }, [options, value, onChange, isInitialized]);

  const handleMultiSelectChange = (selected: string[]) => {
    // Convert array back to comma-separated string
    const commaSeparatedValue = selected.join(',');
    
    // Create a fake event object to maintain compatibility with existing form handling
    const fakeEvent = {
      target: {
        name: 'deal_type',
        value: commaSeparatedValue
      }
    } as React.ChangeEvent<HTMLSelectElement>;
    
    onChange(fakeEvent);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300">
        Deal Type
      </label>
      <MultiSelect
        options={options}
        selected={selectedArray}
        onChange={handleMultiSelectChange}
        placeholder="Select deal types..."
        className="w-full"
        maxDisplayItems={2}
      />
      <p className="text-xs text-zinc-500 dark:text-zinc-400">
        All deal types are selected by default. You can modify the selection as needed.
      </p>
    </div>
  );
} 